import React, { useEffect, useState } from 'react'
import Button from '../../common/button/Button'
import UserName from '../../common/user/UserName'
import Loader from '../../common/loader/Loader'
import iconBack from '../../../images/right-chevrolet.svg';
import PermissionAccordion from '../../permissionAccordion/PermissionAccordion';
import styles from './RolePermission.module.css'
import { useNavigate, useParams } from 'react-router-dom';
import { AppDispatch, IRootState } from '../../../redux/rootReducer';
import { useDispatch } from 'react-redux';
import { getPermissionfromRoleId, updatePermissionsById } from '../../../redux/permissions/actions/permissions.action';
import { useSelector } from 'react-redux';
import Toast from '../../common/toast/Toast';
import { ToastType } from '../Roles';
import PineappleJuice from '../../../images/pineapple-juice.svg'

export interface Permission {
    permissionId: string;
    name: "create" | "read" | "update" | "delete";
    isAllowed: boolean;
}

export interface SubModule {
    moduleId: string;
    name: string;
    permissions: Permission[];
}

export interface Module {
    moduleId: string;
    name: string;
    subModules: SubModule[];
    isVisible?: boolean;
}
export interface TransformedPermission {
    permissionId: string;
    isAllowed: boolean;
}

export interface TransformedSubModule {
    moduleId: string; // This is now subModuleId
    permissions: TransformedPermission[];
}

export type TransformedPermissionsData = TransformedSubModule[];



const RolePermission = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [activeIndex, setActiveIndex] = useState<string | null>(null)
    const navigate = useNavigate();
    const dispatch: AppDispatch = useDispatch();

    const [permissionsData, setPermissionsData] = useState<Module[]>([]);
    const [initialPermissionData, setInitialPermissionData] = useState<Module[]>([])
    const [showToast, setShowToast] = useState(false);
    const [toastType, setToastType] = useState<ToastType | null>(null);
    const [toastMessage, setToastMessage] = useState<string | null>();

    const params = useParams();
    const { id: roleId } = params;
    const { data: permissionsResponse, error: permissionsListError, loading: permissionsListLoading } = useSelector((state: IRootState) => state?.permissionsListReducer)

    const onToggle = (value: string) => {
        if (activeIndex === value) {
            setActiveIndex(null);
        } else {
            setActiveIndex(value);
        }
    };

    useEffect(() => {
        if (roleId) {
            dispatch(getPermissionfromRoleId(roleId))
        }
    }, [roleId]);

    useEffect(() => {
        if (permissionsResponse) {
            setPermissionsData(permissionsResponse?.rolesPermission);
            setInitialPermissionData(permissionsResponse?.rolesPermission);
            permissionsResponse?.rolesPermission?.length && setActiveIndex(permissionsResponse?.rolesPermission[0]?.moduleId)
        }
    }, [permissionsResponse])

    const updatePermissions = (moduleId: string, subModuleId: string, permissionName: string, checked: boolean) => {
        setPermissionsData((prevPermissions) =>
            prevPermissions.map((module) => {
                if (module.moduleId !== moduleId) return module;

                return {
                    ...module,
                    subModules: module.subModules.map((subModule) => {
                        if (subModule.moduleId !== subModuleId) return subModule;

                        return {
                            ...subModule,
                            permissions: subModule.permissions.map((permission) => {
                                if (permissionName === "all") {
                                    return { ...permission, isAllowed: checked };
                                }

                                return permission.name === permissionName
                                    ? { ...permission, isAllowed: checked }
                                    : permission;
                            }),
                        };
                    }),
                };
            })
        );
    };

    const onSuccess = (message: string) => {
        setToastMessage(message);
        setToastType('success');
        setShowToast(true);
        setIsLoading(false);
    }

    const onFailure = (message: string) => {
        setIsLoading(false);
        setToastMessage(message);
        setToastType('error');
        setShowToast(true);
    }

    useEffect(() => {
        if (showToast) {
            setTimeout(() => {
                setShowToast(false);
                setToastType(null);
                setToastMessage(null);
            }, 4000);
        }
    }, [showToast]);

    const transformPermissionsData = (permissionsData: Module[]): TransformedPermissionsData => {
        return permissionsData.flatMap((module) =>
            module.subModules.map((subModule): TransformedSubModule => ({
                moduleId: subModule.moduleId, // Use subModuleId as moduleId
                permissions: subModule.permissions.map((permission): TransformedPermission => ({
                    permissionId: permission.permissionId,
                    isAllowed: permission.isAllowed,
                })),
            }))
        );
    };

    const onUpdatePermission = async () => {
        if (roleId) {
            setIsLoading(true)
            const formattedData: TransformedPermissionsData = await transformPermissionsData(permissionsData);
            dispatch(updatePermissionsById(roleId, formattedData, onSuccess, onFailure))
        }
    }

    const isFormChanged = JSON.stringify(initialPermissionData) !== JSON.stringify(permissionsData);

    return (
        <div className={styles.pageContainer}>
            {(isLoading || permissionsListLoading) && <Loader />}
            <div className={styles.pageHeader}>
                <div className={styles.leftContainer}>
                    <p className={styles.userGreet}>
                        Welcome, <UserName />
                    </p>

                    <h3>Roles & Permission</h3>
                </div>
            </div>

            {permissionsResponse?.rolesPermission && <div className={styles.permissionContainer}>
                <div className={styles.infoHeader}>
                    <Button className={styles.backBtn} onClick={() => navigate('/role-listing')}>
                        <img src={iconBack} alt='back icon' />
                        <span>{permissionsResponse?.roleName}</span>
                    </Button>

                    <Button variant='green' disabled={!isFormChanged} onClick={onUpdatePermission}>
                        <span>Save</span>
                    </Button>
                </div>

                <div className={styles.permissionListing}>
                    {!!permissionsData?.length && permissionsData?.map((module: Module) => {
                        if (module.isVisible) {
                            return (<PermissionAccordion
                                key={module?.moduleId}
                                active={activeIndex === module.moduleId}
                                content={module.subModules}
                                onToggle={onToggle}
                                module={module}
                                updatePermissions={updatePermissions}
                            />)
                        }
                    })}
                </div>
            </div>}

            {
                permissionsListError && <div className={styles.invitationInfo}>
                    <img className={styles.pineappleJuice} src={PineappleJuice} alt="Check" width={132} height={260} />
                    <p className={styles.invitationMessage}>{`Oops! We couldn’t find this role. Please check if you selected the right one.`}</p>
                    <button className={styles.btnGreen} onClick={() => navigate('/role-listing')}>Back to Roles & Permission</button>
                </div>
            }

            {(toastMessage && toastType) && <Toast type={toastType} message={toastMessage} />}
        </div >
    )
}

export default RolePermission
